import { DomainErrorCode } from "./DomainErrorCodes";

export type DomainErrorSeverity = "error" | "warning";

export default class DomainError extends Error {
    code: DomainErrorCode;
    severity: DomainErrorSeverity;
    /** Texto crudo (sin traducir) devuelto por el API, ej. mensajes de validación. */
    details?: string;

    constructor(code: DomainErrorCode, severity: DomainErrorSeverity = "error", details?: string) {
        super(code);

        this.name = "DomainError";
        this.code = code;
        this.severity = severity;
        this.details = details;
    }
}
